module.exports = __webpack_public_path__ + "static/media/giphy_clone_lg.ccff46c4.png";